export const SemiDonut = ({ currentKms, fillColor }: { currentKms: number; fillColor: string }) => {
  const percentage = (currentKms / 500) * 100;
  return (
    <>
      <div className="semi-donut">
        <span>{(percentage * 5).toFixed(0)}/500 km </span>
      </div>
      <style>
        {`
          .semi-donut {       
            width: 300px;
            max-width: 100vw;
            height: 150px;
            position: relative;
            font-size: 22px;
            font-weight: 600;
            overflow: hidden;
            color: ${fillColor};
            display: flex;
            align-items: flex-end;
            justify-content: center;
            box-sizing: border-box;
          }
          
          .semi-donut:after {
            content: '';
            width: 300px;
            max-width: 100vw;
            height: 300px;
            border: 50px solid;
            border-color: rgba(0, 0, 0, 0.15) rgba(0, 0, 0, 0.15) ${fillColor} ${fillColor};
            position: absolute;
            border-radius: 50%;
            left: 0;
            top: 0;
            box-sizing: border-box;
            transform: rotate(calc(1deg * (-45 + ${percentage} * 1.8)));
            animation: fillAnimation 1s ease-in;
          }
          
          @keyframes fillAnimation {
            0% {
              transform: rotate(-45deg);
            }
            50% {
              transform: rotate(135deg);
            }
          }
        `}
      </style>
    </>
  );
};
